import { render, staticRenderFns } from "./PaginationCountless.vue?vue&type=template&id=1dc6b284&scoped=true&"
import script from "./PaginationCountless.vue?vue&type=script&lang=js&"
export * from "./PaginationCountless.vue?vue&type=script&lang=js&"
import style0 from "./PaginationCountless.vue?vue&type=style&index=0&id=1dc6b284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc6b284",
  null
  
)

export default component.exports